<template>
  <div>
    <Modal
      ref="modal"
      title="Change Pipeline Reviewer"
      action="Save"
      action-color="indigo"
      @close-modal="handleCancel"
      @handle-action="handleSubmit"
    >
      <RadioSelect v-if="loaded" v-model="selectedPipelineReviewer" :options="usersForSelect" />
      <RadioSelect v-if="loaded" v-model="selectedPipelineCadence" class="mt-6" :options="cadenceForSelect" />
    </Modal>
  </div>
</template>

<script>
import Modal from '../shared/Modal.vue';
import RadioSelect from '../shared/RadioSelect.vue';
import RailsUtility from '../../utilities/rails.ts';

export default {
  components: {
    Modal,
    RadioSelect,
  },
  props: ['contact'],
  data() {
    return {
      selectedPipelineReviewer: 'No Pipeline Reviewer Needed',
      selectedPipelineCadence: 'Monthly',
      users: [],
      usersForSelect: [{ label: 'No Pipeline Reviewer Needed', description: '' }],
      cadenceForSelect: [
        {
          label: 'Monthly',
          description: 'Sent on the 1st of every month at 11:00 AM PST',
        },
        {
          label: 'Weekly',
          description: 'Sent on Monday of every week at 11:00 AM PST',
        },
        {
          label: 'Semi Monthly',
          description: 'Sent on the 1st and 15th of every month at 11:00 AM PST',
        },
        {
          label: 'Quarterly',
          description: 'Sent on the first day of every quarter at 11:00 AM PST',
        },
      ],
      loaded: false,
    };
  },
  async mounted() {
    await this.getUsers();
    this.selectedPipelineReviewer = this.contact.assignedPipelineReviewer
      ? this.usersForSelect.find(user => user.description == this.contact.assignedPipelineReviewer).label
      : 'No Pipeline Reviewer Needed';

    if (this.contact.pipelineReviewCadence) {
      const words = this.contact.pipelineReviewCadence.split(' ');
      const capitalizedWords = words.map(word => word.charAt(0).toUpperCase() + word.slice(1));
      this.selectedPipelineCadence = capitalizedWords.join(' ');
    } else {
      this.selectedPipelineCadence = this.contact.pipelineReviewCadence;
    }
  },
  methods: {
    async handleSubmit() {
      this.$store.commit('general/showLocalLoadingSpinner');
      const response = await fetch(`/api/team/${this.$route.params.id}`, {
        method: 'PUT',
        body: JSON.stringify({
          pipeline_reviewer_id:
            this.selectedPipelineReviewer != 'No Pipeline Reviewer Needed'
              ? this.usersForSelect.find(user => user.label == this.selectedPipelineReviewer).id
              : null,
          pipeline_review_cadence: RailsUtility.convertToEnumFormat(this.selectedPipelineCadence).toLowerCase(),
        }),
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
      });
      const data = await response.json();
      this.$store.commit('general/hideLocalLoadingSpinner');
      if (data.status != 'error') {
        this.$emit('handleSubmit');
        this.$store.commit('general/showAlert', {
          alertType: 'success',
          alertTitle: 'Teammate pipeline reviewer changed',
          alertDescription:
            "Your Teammates's pipeline reviewer was successfully changed.  Use the button below to dismiss this alert.",
        });
      } else {
        this.$store.commit('general/showAlert', {
          alertType: 'error',
          alertTitle: 'Teammate pipeline reviewer change error',
          alertDescription: data.message,
        });
      }
    },
    handleCancel() {
      this.$emit('handleCancel');
    },
    async getUsers() {
      const response = await fetch(`/api/teams/1`);
      const data = await response.json();
      this.team = data.record;
      for (let member of data.team_members) {
        if (member.status == 'active') {
          this.usersForSelect.push({
            id: member.id,
            label: member.email,
            description: member.name,
            value: member.email,
          });
        }
      }
      this.loaded = true;
    },
  },
};
</script>
